module.exports = __webpack_public_path__ + "static/img/Asset-based_loan_process.7d182cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Asset-based_loan_process.png
// module id = 1538
// module chunks = 5